import T from './DictSelectTag.vue'
const DictSelectTag = {
  install: function (Vue) {
    Vue.component('DictSelectTag',T);
  }
}
export default DictSelectTag;